import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 9443 13566"
    {...props}
  >
    <path
      d="M3168 11399h4802c480 0 845 97 1096 295 251 195 377 462 377 798 0 298-101 553-299 763-201 207-502 311-907 311H1463c-461 0-819-126-1077-380-257-255-386-553-386-898 0-220 82-512 248-876 167-365 349-650 543-861 817-844 1552-1570 2208-2176 656-603 1127-1002 1407-1190 505-355 923-713 1256-1074 336-358 590-725 766-1102 173-377 261-748 261-1109 0-392-95-744-280-1055-188-311-443-549-763-722-323-173-675-258-1055-258-804 0-1435 352-1893 1059-63 91-167 342-311 753-145 412-305 729-487 949-179 219-446 332-795 332-307 0-562-103-763-304-204-201-304-477-304-829 0-421 94-864 285-1322 189-462 475-879 851-1253 377-374 855-675 1436-905C3187 116 3869 0 4647 0c936 0 1737 148 2400 440 430 197 810 468 1133 810 327 345 581 741 760 1193 182 449 273 917 273 1401 0 763-188 1454-565 2075-377 622-763 1112-1155 1464-393 352-1049 907-1973 1661-923 754-1557 1341-1899 1755-148 167-299 368-453 600z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
